import { useMemo } from 'react';
import { RoleType } from '../authentication/hooks/user';
import { useCatalogueService } from '../catalogue/useCatalogueService';
import { useSelectedCustomerFinanceModelForCategoryAndManufacturer } from './useSelectedCustomerFinanceModelForCategoryAndManufacturer';
import { useSelectedPurchaseOrderFinanceModelForCategoryAndManufacturer } from './useSelectedPurchaseOrderFinanceModelForCategoryAndManufacturer';

export const useSelectedFinanceModelForCategoryAndManufacturer = (categoryId: string, manufacturerId: string) => {
  const [configuration, inPurchaseOrder] = useCatalogueService(state => [state.configuration, state.inPurchaseOrder]);

  const selectedStandardiseModel = useSelectedCustomerFinanceModelForCategoryAndManufacturer(
    categoryId,
    manufacturerId
  );
  const selectedPurchaseOrderModel = useSelectedPurchaseOrderFinanceModelForCategoryAndManufacturer(
    categoryId,
    manufacturerId
  );

  return useMemo(() => {
    if (configuration.for !== RoleType.Company) return null;

    if (inPurchaseOrder) return selectedPurchaseOrderModel;

    return selectedStandardiseModel;
  }, [categoryId, manufacturerId]);
};
